import { Instagram } from "lucide-react";
import { SITE } from "@/data/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-bone/10 bg-pine pb-10 pt-16 text-bone">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <p className="max-w-3xl font-serif text-2xl font-light leading-relaxed text-bone/80 lg:text-3xl">
          {SITE.name}, {SITE.credential} — registered massage therapist in
          Vancouver. Deep tissue, sports massage & relaxation in the West End
          and East Vancouver.
        </p>
        <div className="mt-12 flex flex-wrap items-center justify-between gap-6 border-t border-bone/10 pt-8 text-xs uppercase tracking-[0.2em] text-bone/40">
          <span data-testid="footer-copyright">© {new Date().getFullYear()} {SITE.name} {SITE.credential}. All rights reserved.</span>
          <span>West End Physiotherapy · Paper Crane Massage Therapy</span>
        </div>
      </div>
    </footer>
  );
}
